import React, {useState} from "react";

import {Autocomplete} from "@mui/material";
import TextField from "@mui/material/TextField";
import {Button} from "@mui/material";

import Calculation from "./classes/view/calculations/Calculation";
import {enqueueSnackbar} from "notistack";


export const CalculationFormRow = ({view}) => {
    const columnDefs = view.getActiveColumnDefs();
    const newColumnIndex = columnDefs.length;
    const availableOptions = view.getActiveColumnDefs().filter(col => col.isNumber).map(col => {
        return {value: col.getIndex(), label: col.displayName};
    });

    const [leftColumnIndex, setLeftColumnIndex] = useState(null);
    const [rightColumnIndex, setRightColumnIndex] = useState(null);
    const [operationName, setOperationName] = useState(null);

    const disableAddButton = !operationName || leftColumnIndex === null || rightColumnIndex === null;

    return <div className="canold-table-view-menu-form-row" key={"canold-table-calculation-form-row-" + newColumnIndex}>
        <Autocomplete // Choose an Operation
            className={"canold-table-column-view-form-dropdown calculation-form-dropdown"}
            filterSelectedOptions
            id={"canold-table-calculation-operation-dropdown"}
            name={"canold-table-calculation-operation-dropdown"}
            role={"canold-table-calculation-operation-dropdown"}
            key={"canold-table-calculation-operation-dropdown-" + newColumnIndex}
            options={Object.keys(Calculation.operations).map(op => {return {label: op, value: op}})}
            disablePortal={true}
            isOptionEqualToValue={(option, value) => {
                return option.value === value.value;
            }}
            onChange={(evt, option, reason) => {
                if (option && option.value !== null) {
                    setOperationName(option.value);
                } else {
                    setOperationName(null);
                }
            }}
            renderOption={(props, option) => {
                return <li {...props} key={"canold-table-calculation-operation-dropdown-" + option.value}>
                    {option.label}
                </li>
            }}
            onClick={(evt) => {
                evt.stopPropagation(); // Prevent event bubbling
            }}
            renderInput={(params) => {
                return <TextField
                    {...params}
                    label=""
                    onClick={(evt) => {
                        evt.stopPropagation(); // Prevent event bubbling
                    }}
                    placeholder="Add/Subtract/Multiply/Divide"
                    role={"canold-table-calculation-dropdown-input-" + newColumnIndex}
                    key={"canold-table-calculation-operation-dropdown-input-" + newColumnIndex}
                />
            }}
        />

        <Autocomplete // Choose the left column
            className={"canold-table-column-view-form-dropdown"}
            filterSelectedOptions
            id={"canold-table-left-calculation-dropdown"}
            name={"canold-table-left-calculation-dropdown"}
            role={"canold-table-left-calculation-dropdown"}
            key={"canold-table-calculation-left-dropdown-" + newColumnIndex}
            options={availableOptions}
            disablePortal={true}
            isOptionEqualToValue={(option, value) => {
                return option.value === value.value;
            }}
            onChange={(evt, option, reason) => {
                if (option && option.value !== null) {
                    setLeftColumnIndex(option.value);
                } else {
                    setLeftColumnIndex(null);
                }
            }}
            onClick={(evt) => {
                evt.stopPropagation(); // Prevent event bubbling
            }}
            renderOption={(props, option) => {
                return <li {...props} key={"canold-table-left-calculation-dropdown-option-" + option.value}>
                    {option.label}
                </li>
            }}
            renderInput={(params) => {
                return <TextField
                    {...params}
                    label=""
                    onClick={(evt) => {
                        evt.stopPropagation(); // Prevent event bubbling
                    }}
                    placeholder="Column A"
                    role={"canold-table-calculation-dropdown-input-" + newColumnIndex}
                    key={"canold-table-calculation-left-dropdown-input-" + newColumnIndex}
                />
            }}

        />
        <p>and</p>
        <Autocomplete // Choose the right column
            className={"canold-table-column-view-form-dropdown"}
            onClick={(evt) => {
                evt.stopPropagation(); // Prevent event bubbling
            }}
            filterSelectedOptions
            id={"canold-table-right-calculation-dropdown"}
            name={"canold-table-right-calculation-dropdown"}
            role={"canold-table-right-calculation-dropdown"}
            key={"canold-table-right-calculation-dropdown-" + newColumnIndex}
            options={availableOptions}
            disablePortal={true}
            isOptionEqualToValue={(option, value) => {
                return option.value === value.value;
            }}
            onChange={(evt, option, reason) => {
                if (option && option.value !== null) {
                    setRightColumnIndex(option.value);
                } else {
                    setRightColumnIndex(null);
                }
            }}
            renderOption={(props, option) => {
                return <li {...props} key={"canold-table-right-calculation-dropdown-option-" + option.value}>
                    {option.label}
                </li>
            }}
            renderInput={(params) => {
                return <TextField
                    {...params}
                    label=""
                    onClick={(evt) => {
                        evt.stopPropagation(); // Prevent event bubbling
                    }}
                    placeholder="Column B"
                    role={"canold-table-calculation-dropdown-input-" + newColumnIndex}
                    key={"canold-table-calculation-right-dropdown-input-" + newColumnIndex}
                />
            }}
        />
        <Button
            className={"canold-table-calculation-form-row-button-" + newColumnIndex}
            role={"canold-table-add-calculation-button"}
            variant="contained"
            disabled={disableAddButton}
            onClick={() => {
                const leftColumn = columnDefs.find(col => col.getIndex() === leftColumnIndex);
                const rightColumn = columnDefs.find(col => col.getIndex() === rightColumnIndex);
                const operationClass = Calculation.operations[operationName];
                if (!leftColumn) {
                    console.error("Could not find left column with index:", leftColumnIndex, "in", columnDefs);
                }
                if (!rightColumn) {
                    console.error("Could not find right column with index:", rightColumnIndex, "in", columnDefs);
                }
                if (!operationClass) {
                    console.error("Could not find operation class for operation:", operationName);
                }
                const calculation = new Calculation({
                    leftColumn,
                    rightColumn,
                    operation: new operationClass({leftColumn, rightColumn}),
                    index: null, // index will be set by the view
                })
                console.log("Adding calculation:", calculation);
                view.addStateChange(calculation);
                enqueueSnackbar({
                    message: `Added calculation: ${leftColumn.displayName} ${operationClass.symbol} ${rightColumn.displayName}`,
                    options: {
                        variant: "success"
                    }
                });
            }}
        >Add</Button>
    </div>
}
